/**
 * DetailsElement Module
 * helper class
 * for <details> elements
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    document.addEventListener('DOMContentLoaded', () => this.DetailsElementHandling(), false);
    window.addEventListener('resize', () => this.debounce(this.DetailsElementHandling(), 150));
  }

  /**
   * @function DetailsElementHandling
   * @desc adds attribute 'open' to <details> elements
   *       when viewport is >= large (1024px)
   */
  DetailsElementHandling() { // eslint-disable-line class-methods-use-this
    if (window.innerWidth < 1024) { return; }

    document.querySelectorAll('.useful-links__details').forEach((element) => {
      element.setAttribute('open', '');
    });
  }

  /**
   * function debounce
   * @desc debounces the resize event
   * @param {function} func - the function to be debounced
   * @param {number} delay - timeout in ms
   * @return {function} function
   */
  debounce(func, delay) { // eslint-disable-line class-methods-use-this
    let debounceTimer;
    return function (...args) {
      const context = this;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  }
}
